import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/views/Login'
import Main from '@/views/Main'
import Profile from '@/views/Profile'
import ResetPassword from '@/views/ResetPassword'
//
import Home from '@/views/Home/index'
import Contacts from '@/views/Home/Contacts/index'
import TableContacts from '@/views/Home/Contacts/Table'
import Client from '@/views/Home/Contacts/Client'
import PatrimonialLandscape from '@/views/Home/Contacts/PatrimonialLandscape'
import PatrimonialLandscapeUpdate from '@/views/Home/Contacts/PatrimonialLandscapeUpdate'
import Chat from '@/views/Home/Contacts/Chat'
import Investments from '@/views/Home/Contacts/Investments'
import InvestmentsManualForm from '@/common/components/InvestmentsManual/InvestmentsManualForm'
import InvestmentsManual from '@/common/components/InvestmentsManual/InvestmentsManual'
import Activity from '@/views/Home/Activity'
import Board from '@/views/Home/Board'

import { GET_CURRENT_SITE } from '@/common/store/Site/types'

//
import Transactions from '@/views/Transactions/index'
import MyTransactions from '@/views/Transactions/MyTransactions/index'
import TransactionDisplay from '@/views/Transactions/MyTransactions/Display'
import TransactionEdit from '@/views/Transactions/MyTransactions/Edit'
import TransactionsTable from '@/views/Transactions/MyTransactions/Table'
import Documents from '@/views/Transactions/Documents'
//
import IndexActualities from '@/views/Actualities/index'
import Actualities from '@/views/Actualities/Actualities'
import Article from '@/common/components/article'

import IndexLegal from '@/common/components/Legal/index'
import CGU from '@/common/components/Legal/CGU'
import CGV from '@/common/components/Legal/CGV'
import Confidentiality from '@/common/components/Legal/Confidentiality'
import Legals from '@/common/components/Legal/Legals'

// Dev Purpose
import Demo from '@/views/Demo'
//
import MySubscriptions from '@/views/Transactions/MySubscriptions/index'
import SubscriptionsTable from '@/views/Transactions/MySubscriptions/Table'
import SubscriptionDisplay from '@/views/Transactions/MySubscriptions/Display'
import SubscriptionEdit from '@/views/Transactions/MySubscriptions/Edit'
import NotFound from '@/common/components/NotFound'

Vue.use(Router)

const myRouter = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Main,
			redirect: { name: 'Home' },
			children: [
				{
					path: 'home',
					component: Home,
					children: [
						{
							path: '',
							name: 'Home',
							redirect: { name: 'Board' }
						},
						{
							path: 'board',
							name: 'Board',
							component: Board
						},
						{
							path: 'activity',
							name: 'Activity',
							component: Activity
						},
						{
							path: 'contacts',
							component: Contacts,
							children: [
								{
									path: '',
									name: 'Contacts',
									component: TableContacts
								},
								{
									path: 'client/:clientId',
									name: 'Client',
									component: Client
								},
								{
									path: 'client/:clientId/patrimonial-landscape',
									name: 'PatrimonialLandscape',
									component: PatrimonialLandscape
								},
								{
									path: 'client/:clientId/patrimonial-landscape-udpate',
									name: 'PatrimonialLandscapeUpdate',
									component: PatrimonialLandscapeUpdate
								},
								{
									path: 'client/:clientId/chat',
									name: 'ChatClient',
									component: Chat
								},
								{
									path: 'client/:clientId/investments',
									name: 'InvestmentsClient',
									component: Investments
								},
								{
									path: 'client/:clientId/investments-manual',
									name: 'InvestmentsManual',
									component: InvestmentsManual
								},
								{
									path: 'client/:clientId/investments-manual/add',
									name: 'InvestmentsManualAdd',
									component: InvestmentsManualForm
								},
								{
									path: 'client/:clientId/investments-manual/:id/edit',
									name: 'InvestmentsManualForm',
									component: InvestmentsManualForm
								}
							]
						}
					]
				},
				{
					path: 'transactions',
					component: Transactions,
					children: [
						{
							path: '',
							name: 'Transactions',
							redirect: {name: 'Documents'}
						},
						{
							path: 'my-transactions',
							redirect: { name: 'TransactionsTable' },
							component: MyTransactions,
							children: [
								{
									name: 'TransactionsTable',
									component: TransactionsTable,
									path: ''
								},
								{
									name: 'MyTransactionsAdd',
									component: TransactionEdit,
									path: 'add'
								},
								{
									name: 'MyTransactionDisplay',
									component: TransactionDisplay,
									path: ':id'
								},
								{
									name: 'MyTransactionsEdit',
									component: TransactionEdit,
									path: ':id/edit'
								}
							]
						},
						{
							path: 'documents',
							name: 'Documents',
							component: Documents
						},
						{
							path: 'my-subscriptions',
							name: 'subscriptions',
							redirect: { name: 'SubscriptionsTable' },
							component: MySubscriptions,
							children: [
								{
									name: 'SubscriptionsTable',
									component: SubscriptionsTable,
									path: ''
								},
								{
									name: 'MySubscriptionsAdd',
									component: SubscriptionEdit,
									path: 'add'
								},
								{
									name: 'MySubscriptionDisplay',
									component: SubscriptionDisplay,
									path: ':id'
								},
								{
									name: 'MySubscriptionsEdit',
									component: SubscriptionEdit,
									path: ':id/edit'
								}
							]
						}
					]
				},
				{
					path: 'actualities',
					component: IndexActualities,
					redirectTo: { name: 'Actualities' },
					children: [
						{
							path: '',
							component: Actualities,
							name: 'Actualities'
						},
						{
							path: 'article/:id',
							component: Article,
							name: 'Article'
						}
					]
				},
				{
					path: 'profile',
					component: Profile,
					name: 'Profile'
				}
			]
		},
		{
			path: '/login',
			component: Login,
			name: 'Login',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/404',
			component: NotFound,
			name: 'NotFound'
			// meta: {
			// 	requiresAuth: false
			// }
		},
		{
			path: '/reset-password',
			component: Login,
			name: 'ResetPasswordEmailAsk',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/reset-password/:token',
			component: ResetPassword,
			name: 'ResetPassword',
			meta: {
				requiresAuth: false
			}
		},
		{
			component: IndexLegal,
			path: '/legal',
			children: [
				{
					path: 'cgu',
					component: CGU,
					name: 'Cgu'
				},
				{
					path: 'cgv',
					component: CGV,
					name: 'Cgv'
				},
				{
					path: 'legals',
					component: Legals,
					name: 'Legals'
				},
				{
					path: 'confidentiality',
					component: Confidentiality,
					name: 'Confidentiality'
				}
			]
		},
		{
			path: '/demo',
			component: Demo,
			name: 'Demo'
		}
	]
})

myRouter.beforeEach((to, from, next) => {
	if (to.name === 'NotFound') {
		next()
		return
	}
	getSite().then(() => {
		if (store.getters.isAuthenticated && store.getters.isTokenExpired) {
			store.commit('LOGOUT')
			next({ name: 'Login' })
		} else {
			if ((typeof to.meta.requiresAuth !== 'undefined' && to.meta.requiresAuth === false) && store.getters.isAuthenticated) {
				next({ name: 'Main' })
			} else if ((typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) && !store.getters.isAuthenticated) {
				next({ name: 'Login' })
			} else {
				next()
			}
		}
	}).catch(() => {
		if (from.name !== 'NotFound') {
			next({ name: 'NotFound' })
		} else {
			next()
		}
	})
})

function getSite () {
	return store.dispatch(GET_CURRENT_SITE)
}

export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js